module.exports = __webpack_public_path__ + "img/antes_despues_315.56147ca4.png";